import { Component } from 'preact';
import style from './style';
import Image from '@components/image';

import { Stateful } from '@components/pubsub';
import Text from '@components/translate';
import Button from '@components/button';
import Popover from '@components/popover';
import analytics from '@analytics';

const trackContentClick = (content_type, content_id) => {
  analytics({
    event: 'select_content',
    content_type,
    content_id,
  });
};

const LanguageSelectorList = ({ languages }, { closePopOver }) => (
  <div class={style.languageSelectorWrapper} onClick={closePopOver}>
    <Stateful events={['hasTranslationRoute']}>
      {({ hasTranslationRoute = false }) => (
        <ul>
          {languages.map(language => (
            <li>
              <Button
                class={style.languageSelectorButton}
                href={
                  hasTranslationRoute
                    ? window.location.pathname
                        .split('/')
                        .map((item, index) =>
                          index === 1 ? language.code : item
                        )
                        .join('/')
                    : `/${language.code}`
                }
                onClick={() =>
                  window.setTimeout(() => window.location.reload(), 16)
                }
              >
                <span class={style.languageSelectorFlag}>
                  <Image
                    src={`https://cdn.rawgit.com/hjnilsson/country-flags/master/svg/${language.flag}.svg`}
                    alt={language.name}
                    class={style.languageSelectorFlagImage}
                  />
                </span>
                <span class={style.languageSelectorDisplayname}>
                  {language.name}
                </span>
              </Button>
            </li>
          ))}
        </ul>
      )}
    </Stateful>
  </div>
);

class LanguageSelector extends Component {
  state = {
    languages: [
      { code: 'en', name: 'English', flag: 'gb' },
      { code: 'fi', name: 'Suomi', flag: 'fi' },
      { code: 'ee', name: 'Eesti', flag: 'ee' },
    ],
  };
  render(props, { languages }, { lang }) {
    return (
      <div class={style.languageSelectorContainer}>
        <Popover
          toggle={
            <Button class={style.languageToggle}>
              <span class={style.languageSelectorFlag}>
                <Image
                  src={`https://cdn.rawgit.com/hjnilsson/country-flags/master/svg/${
                    languages.filter(({ code }) => code === lang)[0].flag
                  }.svg`}
                  alt={languages.filter(({ code }) => code === lang)[0].name}
                  class={style.languageSelectorFlagImage}
                />
              </span>
              <span class={style.languageSelectorDisplayname}>
                {languages.filter(({ code }) => code === lang)[0].name}
              </span>
            </Button>
          }
          class={style.languageSelector}
        >
          <LanguageSelectorList
            languages={languages}
            hasTranslationRoute={props.hasTranslationRoute}
          />
        </Popover>
      </div>
    );
  }
}

export default class Footer extends Component {
  render(props, state, { lang }) {
    return (
      <footer class={style.footer} style={props.style}>
        <div class="contain">
          <span class={style.logoIntro}>
            <img
              src="/assets/images/logo-text-white-large.png"
              alt="TableOnline Logo"
              class={style.footerLogo}
            />
            <Text p class={style.footerIntroText}>{I18n.t(
              "Make reservations, read reviews, find offers and discover the top restaurants in Finland and Tallinn. Search hundreds of restaurants and find the best!"
            )}</Text>
          </span>
          <LanguageSelector hasTranslationRoute={props.hasTranslationRoute} />
        </div>
        <hr />
        <div class="contain">
          <div class={style.footerLinks}>
            <div class={style.footerLinkContainer}>
              <h6 class={style.footerLinkTitle}>TableOnline.fi</h6>
              <ul class={style.footerLinkList}>
                <li>
                  <a href="/fi">Suomi</a>
                </li>
                <li>
                  <a href="/en">English</a>
                </li>
                <li>
                  <a href="/ee">Eesti</a>
                </li>
              </ul>
            </div>
            <div class={style.footerLinkContainer}>
              <Text h6 class={style.footerLinkTitle}>{I18n.t("About TableOnline")}</Text>
              <ul class={style.footerLinkList}>
                <li>
                  <a
                    onClick={() =>
                      trackContentClick('Footer link', 'Contact us')
                    }
                    href={
                      lang === 'fi'
                        ? `/fi/ota-yhteytta`
                        : lang === 'en'
                        ? `/en/contact-us`
                        : lang === 'ee'
                        ? `/ee/vota-meiega-uhendust`
                        : null
                    }
                  >
                    <Text>{I18n.t("Contact us")}</Text>
                  </a>
                </li>
                <li>
                  <a
                    href={`https://www.tableonline.fi/${lang}/profile`}
                    onClick={() =>
                      trackContentClick('Footer link', 'Restaurant backoffice')
                    }
                  >
                    <Text>{I18n.t("Restaurant backoffice")}</Text>
                  </a>
                </li>
              </ul>
            </div>
            <div class={style.footerLinkContainer}>
              <Text h6 class={style.footerLinkTitle}>{I18n.t("More information")}</Text>
              <ul class={style.footerLinkList}>
                <li>
                  <a
                    href={`/${lang}/terms`}
                    onClick={() =>
                      trackContentClick('Footer link', 'Terms and conditions')
                    }
                  >
                    <Text>{I18n.t("Terms and Conditions")}</Text>
                  </a>
                </li>
                <li>
                  <a
                    href={`/${lang}/giftcard-terms`}
                    onClick={() =>
                      trackContentClick('Footer link', 'Gift card terms of use')
                    }
                  >
                    <Text>{I18n.t("Gift card terms of use")}</Text>
                  </a>
                </li>
                <li>
                  <a
                    href={`/${lang}/privacy`}
                    onClick={() =>
                      trackContentClick('Footer link', 'Privacy policy')
                    }
                  >
                    <Text>{I18n.t("Privacy policy")}</Text>
                  </a>
                </li>
                <li>
                  <a
                    href={`/${lang}/cookies`}
                    onClick={() =>
                      trackContentClick('Footer link', 'Cookie settings')
                    }
                  >
                    <Text>{I18n.t("Cookie settings")}</Text>
                  </a>
                </li>
              </ul>
            </div>
            <div class={style.footerLinkContainer}>
              <Text h6 class={style.footerLinkTitle}>{I18n.t("Partner with TableOnline")}</Text>
              <ul class={style.footerLinkList}>
                <li>
                  <a
                    onClick={() =>
                      trackContentClick('Footer link', 'Join TableOnline')
                    }
                    target="_blank"
                    href={
                      lang === 'fi'
                        ? `/fi/liity-tableonlineen`
                        : lang === 'en'
                        ? `/en/join`
                        : lang === 'ee'
                        ? `/ee/vota-meiega-uhendust`
                        : null
                    }
                  >
                    <Text>{I18n.t("For restaurants")}</Text>
                  </a>
                </li>
                {lang === 'fi' ? (
                  <li>
                    <a
                      href="/fi/affiliate-yhteistyo"
                      onClick={() =>
                        trackContentClick(
                          'Footer link',
                          'Affiliate partnership'
                        )
                      }
                    >
                      <Text>{I18n.t("For affiliate partners")}</Text>
                    </a>
                  </li>
                ) : lang === 'en' ? (
                  <li>
                    <a
                      href="/en/affiliate"
                      onClick={() =>
                        trackContentClick(
                          'Footer link',
                          'Affiliate partnership'
                        )
                      }
                    >
                      <Text>{I18n.t("For affiliate partners")}</Text>
                    </a>
                  </li>
                ) : null}
              </ul>
            </div>
            {lang !== 'ee' ? (
              <div class={style.footerLinkContainer}>
                <Text h6 class={style.footerLinkTitle}>{I18n.t("Follow us")}</Text>
                <ul class={style.footerSocialMediaList}>
                  <li class={style.footerSocialMediaItem}>
                    <a
                      href="https://www.city.fi/blogit/tableonline"
                      onClick={() =>
                        trackContentClick('Footer link', 'TableOnline Blog')
                      }
                    >
                      <img
                        width="22"
                        heigth="16"
                        src="https://static.citycdn.fi/graphics/city-logo-160.png"
                        alt="TableOnlinen ruoka ja ravintola-aiheinen blogi"
                      />
                    </a>
                  </li>
                  <li class={style.footerSocialMediaItem}>
                    <a
                      href="https://www.facebook.com/tableonlinefi"
                      onClick={() =>
                        trackContentClick('Footer link', 'Facebook')
                      }
                    >
                      <svg
                        viewBox="0 0 16 16"
                        xmlns="http://www.w3.org/2000/svg"
                        fill-rule="evenodd"
                        fill="#ffffff"
                        clip-rule="evenodd"
                        stroke-linejoin="round"
                        stroke-miterlimit="1.414"
                      >
                        <path
                          d="M15.117 0H.883C.395 0 0 .395 0 .883v14.234c0 .488.395.883.883.883h7.663V9.804H6.46V7.39h2.086V5.607c0-2.066 1.262-3.19 3.106-3.19.883 0 1.642.064 1.863.094v2.16h-1.28c-1 0-1.195.476-1.195 1.176v1.54h2.39l-.31 2.416h-2.08V16h4.077c.488 0 .883-.395.883-.883V.883C16 .395 15.605 0 15.117 0"
                          fill-rule="nonzero"
                        ></path>
                      </svg>
                    </a>
                  </li>
                  <li class={style.footerSocialMediaItem}>
                    <a
                      href="https://twitter.com/tableonlinefi"
                      onClick={() =>
                        trackContentClick('Footer link', 'Twitter')
                      }
                    >
                      <svg
                        fill="#ffffff"
                        viewBox="0 0 16 16"
                        xmlns="http://www.w3.org/2000/svg"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        stroke-linejoin="round"
                        stroke-miterlimit="1.414"
                      >
                        <path
                          d="M16 3.038c-.59.26-1.22.437-1.885.517.677-.407 1.198-1.05 1.443-1.816-.634.375-1.337.648-2.085.795-.598-.638-1.45-1.036-2.396-1.036-1.812 0-3.282 1.468-3.282 3.28 0 .258.03.51.085.75C5.152 5.39 2.733 4.084 1.114 2.1.83 2.583.67 3.147.67 3.75c0 1.14.58 2.143 1.46 2.732-.538-.017-1.045-.165-1.487-.41v.04c0 1.59 1.13 2.918 2.633 3.22-.276.074-.566.114-.865.114-.21 0-.416-.02-.617-.058.418 1.304 1.63 2.253 3.067 2.28-1.124.88-2.54 1.404-4.077 1.404-.265 0-.526-.015-.783-.045 1.453.93 3.178 1.474 5.032 1.474 6.038 0 9.34-5 9.34-9.338 0-.143-.004-.284-.01-.425.64-.463 1.198-1.04 1.638-1.7z"
                          fill-rule="nonzero"
                        ></path>
                      </svg>
                    </a>
                  </li>
                  <li class={style.footerSocialMediaItem}>
                    <a
                      href="https://instagram.com/tableonlinefi"
                      onClick={() =>
                        trackContentClick('Footer link', 'Instagram')
                      }
                    >
                      <svg
                        fill="#ffffff"
                        viewBox="0 0 16 16"
                        xmlns="http://www.w3.org/2000/svg"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        stroke-linejoin="round"
                        stroke-miterlimit="1.414"
                      >
                        <path d="M14.154 16H1.846C.826 16 0 15.173 0 14.153V1.846C0 .826.826 0 1.846 0h12.308C15.174 0 16 .826 16 1.846v12.307c0 1.02-.826 1.847-1.846 1.847M8 4.923C6.3 4.923 4.923 6.3 4.923 8S6.3 11.077 8 11.077 11.077 9.7 11.077 8C11.077 6.3 9.7 4.923 8 4.923m6.154-2.462c0-.34-.275-.614-.616-.614h-1.846c-.34 0-.615.275-.615.615V4.31c0 .34.276.615.615.615h1.846c.34 0 .616-.276.616-.615V2.46zm0 4.31H12.76c.103.392.163.804.163 1.23 0 2.72-2.204 4.923-4.923 4.923-2.72 0-4.923-2.204-4.923-4.923 0-.426.06-.838.162-1.23H1.845v6.768c0 .34.275.615.616.615h11.076c.34 0 .616-.275.616-.615v-6.77z"></path>
                      </svg>
                    </a>
                  </li>
                  <li class={style.footerSocialMediaItem}>
                    <a
                      href="https://www.youtube.com/channel/UCTj2L1ZmVQSymMEH2wXwfeA"
                      onClick={() =>
                        trackContentClick('Footer link', 'Youtube')
                      }
                    >
                      <svg
                        fill="#ffffff"
                        viewBox="0 0 16 16"
                        xmlns="http://www.w3.org/2000/svg"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        stroke-linejoin="round"
                        stroke-miterlimit="1.414"
                      >
                        <path d="M0 7.345c0-1.294.16-2.59.16-2.59s.156-1.1.636-1.587c.608-.637 1.408-.617 1.764-.684C3.84 2.36 8 2.324 8 2.324s3.362.004 5.6.166c.314.038.996.04 1.604.678.48.486.636 1.588.636 1.588S16 6.05 16 7.346v1.258c0 1.296-.16 2.59-.16 2.59s-.156 1.102-.636 1.588c-.608.638-1.29.64-1.604.678-2.238.162-5.6.166-5.6.166s-4.16-.037-5.44-.16c-.356-.067-1.156-.047-1.764-.684-.48-.487-.636-1.587-.636-1.587S0 9.9 0 8.605v-1.26zm6.348 2.73V5.58l4.323 2.255-4.32 2.24h-.002z"></path>
                      </svg>
                    </a>
                  </li>
                </ul>
              </div>
            ) : (
              <div class={style.footerLinkContainer}>
                <Text h6 class={style.footerLinkTitle}>{I18n.t("Follow us")}</Text>
                <ul class={style.footerSocialMediaList}>
                  <li class={style.footerSocialMediaItem}>
                    <a
                      href="https://www.facebook.com/tableonline.ee/"
                      onClick={() =>
                        trackContentClick('Footer link', 'Facebook')
                      }
                    >
                      <svg
                        viewBox="0 0 16 16"
                        xmlns="http://www.w3.org/2000/svg"
                        fill-rule="evenodd"
                        fill="#ffffff"
                        clip-rule="evenodd"
                        stroke-linejoin="round"
                        stroke-miterlimit="1.414"
                      >
                        <path
                          d="M15.117 0H.883C.395 0 0 .395 0 .883v14.234c0 .488.395.883.883.883h7.663V9.804H6.46V7.39h2.086V5.607c0-2.066 1.262-3.19 3.106-3.19.883 0 1.642.064 1.863.094v2.16h-1.28c-1 0-1.195.476-1.195 1.176v1.54h2.39l-.31 2.416h-2.08V16h4.077c.488 0 .883-.395.883-.883V.883C16 .395 15.605 0 15.117 0"
                          fill-rule="nonzero"
                        ></path>
                      </svg>
                    </a>
                  </li>
                  <li class={style.footerSocialMediaItem}>
                    <a
                      href="https://www.instagram.com/tableonlineeesti/"
                      onClick={() =>
                        trackContentClick('Footer link', 'Instagram')
                      }
                    >
                      <svg
                        fill="#ffffff"
                        viewBox="0 0 16 16"
                        xmlns="http://www.w3.org/2000/svg"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        stroke-linejoin="round"
                        stroke-miterlimit="1.414"
                      >
                        <path d="M14.154 16H1.846C.826 16 0 15.173 0 14.153V1.846C0 .826.826 0 1.846 0h12.308C15.174 0 16 .826 16 1.846v12.307c0 1.02-.826 1.847-1.846 1.847M8 4.923C6.3 4.923 4.923 6.3 4.923 8S6.3 11.077 8 11.077 11.077 9.7 11.077 8C11.077 6.3 9.7 4.923 8 4.923m6.154-2.462c0-.34-.275-.614-.616-.614h-1.846c-.34 0-.615.275-.615.615V4.31c0 .34.276.615.615.615h1.846c.34 0 .616-.276.616-.615V2.46zm0 4.31H12.76c.103.392.163.804.163 1.23 0 2.72-2.204 4.923-4.923 4.923-2.72 0-4.923-2.204-4.923-4.923 0-.426.06-.838.162-1.23H1.845v6.768c0 .34.275.615.616.615h11.076c.34 0 .616-.275.616-.615v-6.77z"></path>
                      </svg>
                    </a>
                  </li>
                </ul>
              </div>
            )}
          </div>
          <div class={`${style.copyright} contain`}>
            <a href="https://alasti.fi?ref=tableonline">
              Copyright © {new Date().getFullYear()}. All rights reserved. Site
              by Alasti.
            </a>
          </div>
        </div>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./components/footer/index.js